<template>
  <div
    class="s-internet-message"
    :class="{
      's-internet-message__variant--low-internet': internetStatus.speed < 0.5,
    }"
  >
    <span v-if="internetStatus.speed < 0.5">
      <i class="icofont-network-tower"></i> {{ $t("lowInternetMessage") }}</span
    >
    <span v-else-if="!internetStatus.connection"
      ><i class="icofont-sad"></i> {{ $t("noInternetMessage") }}</span
    >
  </div>
</template>

<script>
export default {
  props: {
    internetStatus: {
      default: () => {},
    },
  },
};
</script>

<style></style>
